import { FactCheckOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { WizardStepHeader } from './wizard-step-header';

interface ItemValidationHeaderProps {
  productName: string;
}

export function ItemValidationHeader({ productName }: ItemValidationHeaderProps) {
  const { t } = useTranslation('goodsReceiving');
  return (
    <WizardStepHeader
      icon={<FactCheckOutlined />}
      title={t('validateItem', { name: productName })}
      subtitle={t('validateItemSubtitle')}
    />
  );
}
